import CircleBadge from "../common/CircleBadge";

import * as styledElements from "./PaginationStyles";

const ActionButton = ({
  direction,
  alt,
  action,
  disabled,
}: {
  direction: string;
  alt: string;
  action: () => void;
  disabled?: boolean;
}) => (
  <CircleBadge
    disabled={disabled}
    iconProps={{
      src: `/icons/${direction}_arrow.svg`,
      alt,
    }}
    onClick={disabled ? undefined : action}
  />
);

const Pagination = ({
  page,
  maxPage,
  startingIndex,
  totalCount,
  itemsPerPage,
  itemsOnPage,
  onBackAction,
  onForwardAction,
  disabled,
}: {
  page: number;
  maxPage?: number;
  startingIndex: number;
  totalCount: number;
  itemsPerPage: number;
  itemsOnPage: number;
  onBackAction: () => void;
  onForwardAction: () => void;
  disabled?: boolean;
}) => {
  const onLastPageOfMax = maxPage !== undefined ? page >= maxPage : false;
  return (
    <styledElements.Container visible={itemsOnPage > 0}>
      {page != 1 && (
        <ActionButton
          direction="left"
          alt="previous page"
          action={onBackAction}
          disabled={disabled}
        />
      )}
      <styledElements.Description>
        {`${(startingIndex + 1).toLocaleString()} - ${(
          startingIndex + itemsOnPage
        ).toLocaleString()} of ${totalCount.toLocaleString()}`}
      </styledElements.Description>
      {startingIndex + itemsPerPage < totalCount && !onLastPageOfMax && (
        <ActionButton
          direction="right"
          alt="next page"
          action={onForwardAction}
          disabled={disabled}
        />
      )}
    </styledElements.Container>
  );
};

export default Pagination;
